export const CHANGE_CURRENT_PAGE = 'sitesManagement/CHANGE_CURRENT_PAGE'
export const FETCH_SITES_MANAGEMENT_DASHBOARD = 'sitesManagement/FETCH_SITES_MANAGEMENT_DASHBOARD'
export const REDEPLOY_ALL_LANDINGS = 'sitesManagement/REDEPLOY_ALL_LANDINGS'
